import { render } from "./LinksSheet.vue?vue&type=template&id=5ddbbc60&ts=true"
import script from "./LinksSheet.vue?vue&type=script&lang=ts"
export * from "./LinksSheet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__